import { MessagesMockApi } from 'app/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { NotificationsMockApi } from 'app/mock-api/common/notifications/api';
import { SearchMockApi } from 'app/mock-api/common/search/api';
import { ShortcutsMockApi } from 'app/mock-api/common/shortcuts/api';
import { UserMockApi } from 'app/mock-api/common/user/api';

/**
 * Mock handlers registered in every build (dev and prod — same list so what
 * you test locally is what ships).
 *
 * Only the Fuse shell fixtures the live admin still reads over relative URLs:
 * sidebar navigation, header user / messages / notifications / shortcuts, and
 * the header search. Real admin APIs use absolute `environment.API_BASE_URL`
 * and never match these handlers.
 *
 * Removed 2026-10-27 (security finding 5): `AuthMockApi` (hard-coded JWT
 * signer string) and the unused Fuse demo app/dashboard mocks (academy,
 * calendar, chat, mailbox, …). Those files remain under `src/app/mock-api/`
 * but are no longer imported, so they stay out of the bundle. Fuse leftover
 * routes (`forgot-password`, email `sign-in`, `sign-up`, `unlock-session`)
 * that called `api/auth/*` are not used by MetaMask login.
 */
export const mockApiServices = [
    MessagesMockApi,
    NavigationMockApi,
    NotificationsMockApi,
    SearchMockApi,
    ShortcutsMockApi,
    UserMockApi
];
